import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AiOutlineClose, AiOutlineShoppingCart } from "react-icons/ai";
import { useSelector } from "react-redux";
import { FaChevronDown, FaChevronLeft } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";


const menuItems = [
  { title: "خانه", href: "/home" },
  { title: "درباره ما", href: "/about" },
  { title: "محصولات", href: "/home", scrollTo: "products" },
  { title: "تماس با ما", href: "/contact-us" },
  {
    title: "وبلاگ",
    href: "#",
    children: [
      { title: "انواع نوشیدنی‌های قهوه", href: "/coffee/drinks" },
      { title: "قهوه تازه رُست شده", href: "/coffee/fresh" },
      { title: "بهترین روش‌های نگهداری قهوه در خانه و کارخانه", href: "/coffee/storage" },
      { title: "تاریخچه قهوه و ورود آن به ایران", href: "/coffee/history" },
      { title: "حقیقت‌ها و باورهای غلط", href: "/coffee/cafein" },
      { title: "بهترین دانه ها", href: "/coffee/brewing" },
    ],
  },
  { title: "سبد خرید", href: "/cart" },
];

const Header = () => {
  const navigation = useNavigate()
  const cartQuantity = useSelector(state => state.cart.totalQuantity || 0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);

  const handleLogoClick = () => {
    navigation('/home')
  }

  const handleDesktopNavClick = (e, item) => {
    if (item.scrollTo === "products") {
      e.preventDefault();
      navigation("/home", { state: { scrollTo: "products" } });
    }
  };

  const closeMenu = () => {
    // setIsAnimatingOut(true);
    setTimeout(() => {
      setIsMenuOpen(false);
      // setIsAnimatingOut(false);
    }, 300); // match transition duration
  };

  return (
    <>
      <header className="fixed top-0 w-full z-50 bg-backgroundBox md:bg-white/85 backdrop-blur-sm shadow-amber-200">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between text-black font-bold" dir="rtl">
          {/* Logo */}
          <div className="text-2xl flex items-center gap-2 font-extrabold cursor-pointer" onClick={handleLogoClick}>
            <span className="relative top-1 tracking-wide bg-gradient-to-r from-[#FF8C42] via-[#FF6F00] to-[#D18F00] text-transparent bg-clip-text">
              SilkRoad
            </span>
            <img src="/images/logo.png" alt="SilkRoad Logo" className="w-10 h-12 object-contain" />
          </div>


          {/* Nav */}
          <nav className="hidden md:flex gap-6 text-sm items-center">
            {menuItems.map((item, index) => {
              const isCartItem = item.href === "/cart";
              const hasChildren = item.children && item.children.length > 0;

              return (
                <div key={index} className="relative group">
                  {hasChildren ? (
                    <>
                      <button
                        type="button"
                        className="pb-1 border-b-2 border-transparent hover:border-neonOrange transition-all flex items-center gap-1"
                      >
                        <span>{item.title}</span>
                        <FaChevronDown className="text-[10px] transition-transform group-hover:rotate-180" />
                      </button>

                      {/* Desktop Blog Dropdown */}
                      <div className="
                      absolute right-auto left-0 top-full mt-2 w-72
                     bg-white rounded-lg shadow-lg
                      border border-gray-100
                      opacity-0 invisible
                      translate-y-2
                      group-hover:opacity-100
                      group-hover:visible
                      group-hover:translate-y-0
                      transition-all duration-200
                      z-50"
                      >
                        <div className="py-2">
                          {item.children.map((child, childIndex) => (
                            <Link
                              key={childIndex}
                              to={child.href}
                              className="
                          block px-4 py-3 text-sm text-gray-700 hover:bg-orange-50 hover:text-neonOrange
                          transition-colors
                        "
                            >
                              {child.title}
                            </Link>
                          ))}
                        </div>
                      </div>
                    </>
                  ) : <Link
                    key={index}
                    to={item.href}
                    onClick={(e) => handleDesktopNavClick(e, item)}
                    className={`pb-1 border-b-2 transition-all relative ${item.active
                      ? "border-neonOrange text-neonOrange"
                      : "border-transparent hover:border-neonOrange"
                      }`}
                  >
                    <span>{item.title}</span>

                    {/* نمایش تعداد سبد خرید فقط برای آیتم سبد خرید در دسکتاپ/تبلت */}
                    {isCartItem && cartQuantity > 0 && (
                      <span className="bg-neonOrange text-white absolute -left-4 -top-2 text-xs w-5 h-5 rounded-full flex items-center justify-center font-bold leading-none shadow-sm">
                        {cartQuantity}
                      </span>
                    )}
                  </Link>}
                </div>
              )
            })}
          </nav>

          {/* Mobile menu & Cart icons */}
          <div className="md:hidden flex items-center gap-6">
            {/* Cart Icon */}
            <div
              className="relative cursor-pointer"
              onClick={() => navigation("/cart")}
              title="سبد خرید"
            >
              <AiOutlineShoppingCart
                className="text-2xl fill-current"
                style={{
                  fill: "url(#cartGradient)",
                }}
              />
              <svg width="0" height="0">
                <linearGradient id="cartGradient" x1="0" y1="0" x2="1" y2="0">
                  <stop stopColor="#FF8C42" offset="0%" />
                  <stop stopColor="#FF6F00" offset="50%" />
                  <stop stopColor="#D18F00" offset="100%" />
                </linearGradient>
              </svg>

              {cartQuantity > 0 && (
                <span className="absolute -top-2 -right-2 bg-neonOrange text-white rounded-full text-xs w-5 h-5 flex items-center justify-center font-semibold">
                  {cartQuantity}
                </span>
              )}
            </div>
            {/* Hamburger Menu */}
            <div
              className="relative top-1 tracking-wide bg-gradient-to-r from-[#FF8C42] via-[#FF6F00] to-[#D18F00] text-transparent bg-clip-text text-2xl cursor-pointer select-none"
              onClick={() => setIsMenuOpen(true)}
              aria-label="Open menu"
              title="منوی موبایل"
            >
              ☰
            </div>
          </div>
        </div>
      </header >
      {/* Overlay */}
      {
        isMenuOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40"
            onClick={closeMenu}
          />
        )
      }

      {/* Mobile Slider Menu */}
      {/* Mobile Slider Menu */}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            key="sidebar"
            initial={{ x: "-100%" }}
            animate={{ x: 0 }}
            exit={{ x: "-100%" }}
            transition={{ duration: 0.35, ease: "easeInOut" }}
            className="fixed top-0 left-0 w-64 h-full bg-white z-50 shadow-lg"
          >
            <div className="p-4 flex justify-between items-center border-b bg-white">
              <span className="font-extrabold tracking-wide bg-gradient-to-r from-[#FF8C42] via-[#FF6F00] to-[#D18F00] text-transparent bg-clip-text">
                SilkRoad
              </span>
              <button onClick={closeMenu} className="text-xl">
                <AiOutlineClose />
              </button>
            </div>

            <nav className="flex flex-col p-4 gap-2 text-right bg-white h-screen overflow-y-auto">
              {menuItems.map((item, index) => {
                const hasChildren = item.children && item.children.length > 0;
                const isOpen = openIndex === index;

                return (
                  <div key={index}>
                    {!hasChildren ? (
                      <Link
                        to={item.href}
                        className="block py-2 text-black hover:text-neonOrange"
                        onClick={(e) => {
                          e.preventDefault();
                          setOpenIndex(null);
                          setIsMenuOpen(false);

                          if (item.scrollTo === "products") {
                            navigation("/home", { state: { scrollTo: "products" } });
                          } else {
                            navigation(item.href);
                          }
                        }}
                      >
                        {item.title}
                      </Link>
                    ) : (
                      <>
                        <button
                          onClick={() => setOpenIndex(isOpen ? null : index)}
                          className="flex items-center justify-between w-full py-2 text-black hover:text-neonOrange"
                        >
                          <span>{item.title}</span>
                          {isOpen ? (
                            <FaChevronDown className="text-sm" />
                          ) : (
                            <FaChevronLeft className="text-sm" />
                          )}
                        </button>

                        {/* Animated submenu */}
                        <AnimatePresence>
                          {isOpen && (
                            <motion.div
                              key="submenu"
                              initial={{ height: 0, opacity: 0 }}
                              animate={{ height: "auto", opacity: 1 }}
                              exit={{ height: 0, opacity: 0 }}
                              transition={{ duration: 0.3, ease: "easeInOut" }}
                              className="ml-4 mt-1 flex flex-col gap-2 pr-3 overflow-hidden"
                            >
                              {item.children.map((child, cIdx) => (
                                <Link
                                  key={cIdx}
                                  to={child.href}
                                  className="block py-1 text-sm text-gray-700 hover:text-neonOrange"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setIsMenuOpen(false);
                                    navigation(child.href);
                                  }}
                                >
                                  {child.title}
                                </Link>
                              ))}
                            </motion.div>
                          )}
                        </AnimatePresence>
                      </>
                    )}
                  </div>
                );
              })}
            </nav>

          </motion.div>
        )}
      </AnimatePresence>

    </>
  );
};

export default Header;
